import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  	selector: '[phone-mask]'
})
export class PhoneMaskDirective {

  	constructor(
		  private _model: NgControl,
	) {
		// formContro
		console.log(_model);
		debugger;
	}

	ngOnChanges() {
		console.log('changes');
	}

	ngOnInit() {
		console.log('directive.oninit');
		const model = this._model;

		// this doesn't seem to faze the initial value... 
		model.valueChanges
			.subscribe(huh => {
				console.log('change occured...', huh);
			})
	}

	@HostListener('input', ['$event']) inputChange() {
		const m = this._model,
			newVal = m.value.replace(/\D/g, ''),
			mask = [
				newVal.substring(0, 3),
				newVal.substring(3, 6),
				newVal.substring(6, 10)
			]
			.filter(v => !!v);

		m.control.setValue(mask.join(''));
		m.valueAccessor.writeValue(mask.join('-'));
	}

}
